import { render, staticRenderFns } from "./PageTitleCreate.vue?vue&type=template&id=7349d011"
import script from "./PageTitleCreate.vue?vue&type=script&lang=ts"
export * from "./PageTitleCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports